import { calculateUnitClimatisationDotValues } from "./calculateClimatisationDotValuesForUnit";
import { calculateConformityStatusDotValues } from "./calculateConformityDotValues";
import { calculateDangerousMaterialsForUnit } from "./calculateDangerousMaterialsForUnit";
import { calculateElectricityDotValues } from "./calculateElectricityDotValues";
import { calculateEnergyPerformanceDotValues } from "./calculateEnergyPerformanceDotValues";
import { calculateFireSecurityUnitDotValues } from "./calculateFireSecurityUnitDotValues";
import { calculateTaxationDotValues } from "./calculateTaxationDotValues";
import { calculateUnitDevices } from "./calculateUnitDevicesDotValues";
import { calculateUnitVisualInspectionDotValues } from "./calculateUnitVisualInspectionDotValues";
import { calculateWaterUnitInfoStatus } from "./calculateWaterUnitInfoDotValues";

export const getNumericValuesForUnit = async (entity: any, column: any, session: any) => {

  // Default values if no specific logic is defined for the column
  let dotValues = {
    red: { count: 0, labels: [] as any[] },
    orange: { count: 0, labels: [] as any[] },
    green: { count: 0, labels: [] as any[] },
    transparent: { count: 0, labels: [] as any[] },
  };

  const mergeDotValues = (dotValuesList: any) => {
    return dotValuesList.reduce((acc: any, dotValues: any) => {
        Object.keys(dotValues).forEach(color => {
            acc[color].count += dotValues[color].count;
            acc[color].labels = [...acc[color].labels, ...dotValues[color].labels];
        });
        return acc;
    }, {
        red: { count: 0, labels: [] },
        orange: { count: 0, labels: [] },
        green: { count: 0, labels: [] },
        transparent: { count: 0, labels: [] },
    });
  };

  if (column === 'Cumulative') {
    // Collect all dotValues in an array - now with await for electricity and energy performance
    const allDotValues = await Promise.all([
        calculateElectricityDotValues(entity.electricityInfo || {}, session),
        calculateEnergyPerformanceDotValues(entity || {}, session),
        calculateFireSecurityUnitDotValues(entity.fireSecurityUnitInfo || {}),
        calculateDangerousMaterialsForUnit(entity, session),
        calculateUnitVisualInspectionDotValues(entity.unitInspectionInfo || {}),
        entity.devices ? calculateUnitDevices({ devices: entity.devices }) : calculateUnitDevices({ devices: [] }),
        calculateUnitClimatisationDotValues({ unitClimatisationInfo: entity.climatisationInfo || {} }),
        calculateConformityStatusDotValues(entity.unitConformityInfo || {}, entity, session),
        calculateTaxationDotValues(entity || {}, session)
    ].filter(Boolean)); // Filter out nulls in case some info is not available

    return mergeDotValues(allDotValues);
  }

  if (column === 'Waterhuishouding') {
    return calculateWaterUnitInfoStatus(entity.waterUnitInfo || {});
  }

  if (column === 'Elektriciteit') {
    return await calculateElectricityDotValues(entity || {}, session);
  }

  if (column === 'Gevaarlijke stoffen') {
    return calculateDangerousMaterialsForUnit(entity, session);
  }

  if (column === 'Brandveiligheid') {
    return calculateFireSecurityUnitDotValues(entity.fireSecurityUnitInfo || {});
  }

  if (column === "Klimatisatie") {
    return calculateUnitClimatisationDotValues({ unitClimatisationInfo: entity.climatisationInfo || {} });
  }

  if (column === 'Vis. inspectie') {
    return calculateUnitVisualInspectionDotValues(entity.unitInspectionInfo || {});
  }

  if (column === 'Toestellen') {
    return entity.devices 
      ? calculateUnitDevices({ devices: entity.devices }) 
      : calculateUnitDevices({ devices: [] });
  }

  if (column === 'Woonconformiteit') {
    return calculateConformityStatusDotValues(entity.unitConformityInfo || {}, entity, session);
  }

  if (column === 'Energieprestaties') {
    return calculateEnergyPerformanceDotValues(entity || {}, session);
  }

  if (column === 'Taxatie') {
    return calculateTaxationDotValues(entity || {}, session);
  }

  return dotValues;
};
